
const digest = '3d2440f9e6829637518f75ce8765871afa10f5f1acc1c06526ac1ec57f024c3b';
const css = `._embedInline_1gdfa_1 {
  display: inline-block;
  vertical-align: middle;
  margin: 0.5em;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"embedInline":"_embedInline_1gdfa_1"};
export { css, digest };
  